import { initializeApp } from 'firebase/app';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: 'capsat-project.firebaseapp.com',
  projectId: 'capsat-project',
  storageBucket: 'capsat-project.firebasestorage.app',
  messagingSenderId: '228459501821',
  appId: '1:228459501821:web:f1c2414f5486a7a34ac694',
  measurementId: 'G-78P80DZNTG',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Firebase App Check: forces every Firestore/Auth/Storage request to carry
// an attestation token proving it came from our actual web app via a real
// reCAPTCHA challenge. Without it, an attacker who copies the auth token
// out of devtools can replay it from Postman/curl. With it, that replay
// fails because Postman can't mint an App Check token for our domain.
// Enforcement is toggled per service in Firebase Console → App Check.
//
// MUST run after initializeApp but before any getAuth/getFirestore/
// getStorage call so the SDK attaches App Check tokens from the start.
const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

if (process.env.NODE_ENV === 'production') {
  // App Check is only active in production. Enforcement is configured in
  // Firebase Console → App Check → APIs. In development the reCAPTCHA
  // script is skipped entirely (no PAT calls, no badge, no noise).
  if (recaptchaSiteKey !== undefined && recaptchaSiteKey !== '') {
    initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(recaptchaSiteKey),
      isTokenAutoRefreshEnabled: true,
    });
  } else {
    console.warn(
      'REACT_APP_RECAPTCHA_SITE_KEY is not set; Firebase App Check is ' +
        'disabled in production. All requests will be rejected once ' +
        'enforcement is enabled in the Firebase Console.',
    );
  }
}

const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage();

export { app, auth, db, storage };
